import api from './api';

export default {
  getAll() { return api.get('/testimonials'); },
  getById(id: number) { return api.get(`/testimonials/${id}`); },
  create(data: any) { return api.post('/testimonials', data); },
  update(id: number, data: any) { return api.put(`/testimonials/${id}`, data); },
  delete(id: number) { return api.delete(`/testimonials/${id}`); }
};
